document.addEventListener("DOMContentLoaded", () => {

  const sections = document.querySelectorAll(
    ".rr-signature, .rr-featured-products, .rr-why"
  );

  if (!("IntersectionObserver" in window)) {
    sections.forEach(section => section.classList.add("rr-visible"));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("rr-visible");
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });

  sections.forEach(section => {
    section.classList.add("rr-hidden");
    observer.observe(section);
  });

});